import { OpeningHoursToday } from '../infoscreen-module.types';

/** Minutes the screen wakes before opening and stays on after closing. */
export const SLEEP_MARGIN_MINUTES = 15;

/**
 * Whether the screen should be dark now. Only opening hours that are actually set up decide it:
 *
 * - no opening hours for the day (`null`) → never dark, as before;
 * - a closed day (closed weekday, holiday, blocked all day) → dark all day;
 * - otherwise on from `margin` minutes before each interval opens until `margin` minutes after it
 *   closes, and dark in between — so a midday gap longer than twice the margin is dark too.
 *
 * Wall-clock comparison in the screen's own time, which is how the opening hours are written.
 */
export function isAsleep(day: OpeningHoursToday | null, now: Date, margin = SLEEP_MARGIN_MINUTES): boolean {
  if (!day) return false;
  if (!day.intervals.length) return true;

  const minutes = now.getHours() * 60 + now.getMinutes();
  return !day.intervals.some((interval) => {
    const opens = toMinutes(interval.opens) - margin;
    const closes = toMinutes(interval.closes) + margin;
    return minutes >= opens && minutes < closes;
  });
}

/** "07:30" → 450. "24:00" (a close at midnight) → 1440. */
function toMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + (m || 0);
}
